(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/ssn-input/assets/javascripts/components/prescript.js') >= 0) return;  svs.modules.push('/components/ui/ssn-input/assets/javascripts/components/prescript.js');

svs.ui = svs.ui || {};
svs.ui.reactFormInputs = svs.ui.reactFormInputs || {};
svs.ui.ReactFormInputs = svs.ui.reactFormInputs;


 })(window);